import { Component } from '@angular/core';

@Component({
    selector: 'abandon-notice',
    templateUrl: './abandon-notice.component.html'
})

export class AbandonNoticeComponent {
}
